import { render } from "./box-total-moviment.vue?vue&type=template&id=502b2d9d"
import script from "./box-total-moviment.vue?vue&type=script&lang=js"
export * from "./box-total-moviment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__